export default __webpack_public_path__ + "static/p_01-fe53a5af38c083b4fa6afaf179695916.png";